import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

const isNumericString = (value: string) => /^\d+$/.test(value);

const parsePrepTime = (prepTime: string): string | null => {
  const trimmed = prepTime.trim();
  if (!trimmed) {
    return null;
  }
  const lower = trimmed.toLowerCase();
  if (lower.includes("min") || lower.includes("hour")) {
    return trimmed;
  }
  if (isNumericString(trimmed)) {
    return `${trimmed} min`;
  }
  return trimmed;
};

const parsePortionSize = (portionSize: string): string | null => {
  const trimmed = portionSize.trim();
  if (!trimmed) {
    return null;
  }
  const lower = trimmed.toLowerCase();
  if (lower.includes("serving")) {
    return trimmed;
  }
  if (isNumericString(trimmed)) {
    return `${trimmed} / serving`;
  }
  return trimmed;
};

export interface MealDetailMetaProps {
  prepTime?: string | null;
  portionSize?: string | null;
}

export const MealDetailMeta = memo(function MealDetailMeta({
  prepTime,
  portionSize,
}: MealDetailMetaProps) {
  const prepDisplay = prepTime != null ? parsePrepTime(prepTime) : null;
  const portionDisplay = portionSize != null ? parsePortionSize(portionSize) : null;

  if (!prepDisplay && !portionDisplay) {
    return null;
  }

  return (
    <p
      className={cn(
        textVariants.bodySingleLine,
        "flex h-7 items-center justify-center gap-4 opacity-70",
      )}
    >
      {prepDisplay ? (
        <span className={textVariants.bodySingleLine}>Prep time: {prepDisplay}</span>
      ) : null}
      {prepDisplay && portionDisplay ? (
        <span className="text-4xl select-none" aria-hidden="true">
          •
        </span>
      ) : null}
      {portionDisplay ? (
        <span className={textVariants.bodySingleLine}>{portionDisplay}</span>
      ) : null}
    </p>
  );
});
